import { IconName, MemreFlexBox, MemreIcon, MemreInput, MemreText } from 'components/core';
import { Ratings } from 'services/useItem.service/interactions';
import { useAuthoringContext } from '../AuthoringContext';

export default function RatingHeadings() {
  const rating = useAuthoringContext()?.item as Ratings;

  const handleMinValueChange = (e) => {
    rating.minLabel.update(e.target.value);
  };

  const handleMaxValueChange = (e) => {
    rating.maxLabel.update(e.target.value);
  };

  return (
    <MemreFlexBox direction="row" justify="center" align="center" gap={4}>
      <MemreInput label="Min Label" value={rating.minLabel.text} onBlur={handleMinValueChange} />
      {new Array(5).fill(0).map((_, i) => (
        <MemreFlexBox key={i} direction="column" align="center" gap={0.5}>
          <MemreText sx={{ color: 'grey' }}>{i + 1}</MemreText>
          <MemreIcon iconName={IconName.star} fontSize="1.2em" color="grey" />
        </MemreFlexBox>
      ))}
      <MemreInput label="Max Label" value={rating.maxLabel.text} onBlur={handleMaxValueChange} />
    </MemreFlexBox>
  );
}
